"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const option_1 = __importDefault(require("./option"));
const answersMap = {
    '-1': 'q%s-no-answer',
    '-2': 'q%s-no-opinion-answer',
    '-3': 'q%s-other',
    '-4': 'q%s-other-with-text'
};
function SpecialOption({ option, clickHandler, value, multipleChoice, questionIndex, limitReached }) {
    const { label = '', checked, enabled = false } = option;
    const controlProps = {
        id: answersMap[value].replace('%s', questionIndex),
        label,
        checked,
        value,
        handleClickOption: clickHandler,
        multipleChoice,
        disabled: limitReached && !checked
    };
    return enabled ? (0, jsx_runtime_1.jsx)(option_1.default, Object.assign({}, controlProps)) : null;
}
exports.default = SpecialOption;
SpecialOption.defaultProps = {
    option: {
        enabled: false
    },
    value: -1,
    multipleChoice: false,
    questionIndex: -1
};
